import * as React from 'react';
import { connect } from 'react-redux';
import ApplicationState from '../../application/core/State';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import OrderModel from '../../domain/Order';
import OrdersToolbar from './OrdersToolbar';
import './Order.css';
import OrderFooter from './OrderFooter';
import Spreadsheet from './Spreadsheet';
import { Filter } from '../../domain/Filter';
import OrderPageEntered from '../../application/products/events/OrderPageEntered';
import { monthByNumber } from '../admin/getEstimationMonths';
import Channels from '../channels/Channels';
import OrdersFilterSelected from '../../application/order/events/OrdersFilterSelected';
import OrdersFilterRemoved from '../../application/order/events/OrdersFilterRemoved';
import OrderList from './OrderList';
import headers from './headers';
import Loader from '../common/Loader';

interface StateProps {
    order?: OrderModel;
    orderFilters: Filter[];
}

interface State {
    spreadsheetView: boolean;
}

class Order extends React.PureComponent<StateProps & DispatchProps, State> {
    constructor(props: DispatchProps & StateProps) {
        super(props);
        this.state = {
            spreadsheetView: false
        };
    }

    public componentDidMount(): void {
        this.props.dispatch(new OrderPageEntered());
    }

    public render(): JSX.Element {
        if (!this.props.order) {
            return <Loader />;
        }
        return (
            <div className="current-order">
                <OrdersToolbar orderFilters={this.props.orderFilters} />
                <div className="current-order-wrapper">
                    <Channels
                        channelSelected={this.channelSelected}
                        channelDeSelected={this.channelDeSelected}
                        selectedNode={this.getSelectedNode()}
                        color="orders-green"
                    />

                    {!this.state.spreadsheetView ? (
                        <OrderList />
                    ) : (
                        <Spreadsheet headers={headers} month={monthByNumber[this.props.order.month.month]} />
                    )}
                </div>
                <OrderFooter />
            </div>
        );
    }

    private channelSelected = (channelId: number): void => {
        this.props.dispatch(new OrdersFilterSelected({ type: 'nodeCategory', value: channelId, single: true }));
    };

    private channelDeSelected = (): void => this.props.dispatch(new OrdersFilterRemoved({ type: 'nodeCategory' }));

    private getSelectedNode = (): number | undefined => {
        const filter = this.props.orderFilters.find((f: Filter) => f.type === 'nodeCategory');
        return filter ? (filter.value as number) : -1;
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    order: state.order.order,
    orderFilters: state.order.orderFilters
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Order);



// WEBPACK FOOTER //
// ./src/view/order/Order.tsx